import React from 'react';
import { Spin, Badge } from 'antd';

/**
 * Same visual rhythm as QuickActionCard: icon → title → subtitle; list left-aligned below.
 */
const FiringAlertsWelcomeCard = ({ isDark, loading, rows, onAlertClick }) => {
  const muted = isDark ? '#8b949e' : '#8c8c8c';
  const titleColor = isDark ? '#e6edf3' : '#1a1a1a';

  const shell = {
    cursor: 'default',
    padding: '18px 16px',
    backgroundColor: isDark ? '#161b22' : '#fff',
    borderRadius: '12px',
    boxShadow: isDark ? '0 1px 3px rgba(0,0,0,0.3)' : '0 1px 3px rgba(0,0,0,0.06)',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    border: isDark ? '1px solid #30363d' : '1px solid #e8e8e8',
    minWidth: 0,
  };

  const iconWrap = {
    width: '44px',
    height: '44px',
    borderRadius: '10px',
    backgroundColor: '#ff4d4f',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px',
    flexShrink: 0,
  };

  const subtitleStyle = {
    margin: 0,
    fontSize: '13px',
    color: muted,
    lineHeight: 1.4,
  };

  const onMouseEnter = (e) => {
    e.currentTarget.style.transform = 'translateY(-2px)';
    e.currentTarget.style.boxShadow = isDark
      ? '0 4px 12px rgba(0,0,0,0.4)'
      : '0 4px 12px rgba(0,0,0,0.1)';
  };

  const onMouseLeave = (e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = isDark
      ? '0 1px 3px rgba(0,0,0,0.3)'
      : '0 1px 3px rgba(0,0,0,0.06)';
  };

  return (
    <div
      className="ai-welcome-firing-card"
      style={shell}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div style={iconWrap}>🔔</div>

      <div style={{ minWidth: 0 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap',
            marginBottom: 2,
          }}
        >
          <h3
            style={{
              margin: 0,
              fontSize: '15px',
              fontWeight: 600,
              color: titleColor,
            }}
          >
            Firing alerts
          </h3>
          {!loading && (
            <Badge
              count={rows.length}
              showZero
              overflowCount={99}
              className={`ai-welcome-firing-card__count-badge ${
                rows.length > 0 ? 'is-firing' : 'is-clear'
              }`}
            />
          )}
        </div>

        {loading ? (
          <p style={{ ...subtitleStyle, display: 'flex', alignItems: 'center', gap: 8 }}>
            <Spin size="small" />
            Checking alerts…
          </p>
        ) : rows.length === 0 ? (
          <p style={subtitleStyle}>
            All clear — no firing alerts.
          </p>
        ) : (
          <>
            <p style={{ ...subtitleStyle, marginBottom: 8 }}>
              {rows.length === 1
                ? '1 alert · select to ask the assistant'
                : `${rows.length} alerts · select to ask the assistant`}
            </p>
            <ul className="ai-welcome-firing-card__list">
              {rows.map((row) => (
                <li key={row.name}>
                  <button
                    type="button"
                    className={`ai-welcome-firing-card__row ${isDark ? 'is-dark' : ''}`}
                    onClick={() => onAlertClick(row.name)}
                  >
                    <span className="ai-welcome-firing-card__row-name">{row.name}</span>
                    <span className="ai-welcome-firing-card__row-meta">
                      <span>{row.started}</span>
                      {row.count > 1 && (
                        <Badge count={row.count} size="small" style={{ backgroundColor: '#ff4d4f' }} />
                      )}
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
};

export default FiringAlertsWelcomeCard;
